

export const SORT_ICON_NAME = {
  ASC: 'arrowup',
  DESC: 'arrowdown'
};